import { AbstractControl, ValidatorFn, FormGroup, ValidationErrors } from '@angular/forms';

export function EqualValidator(base: string, parent: string): ValidatorFn {
   return (groupform: FormGroup): ValidationErrors => {
      const baseValue = groupform.get(base).value;
      const parentValue = groupform.get(parent).value;
      return baseValue === parentValue ? null : { notmach: { base, parent } };
   };
}
